<template>
  <div class="border-bottom pb-3">
    <div v-if="!autocompleteDisabled" class="form-group" style="position: relative;">
      <div class="d-flex">
        <label>Article Link</label>
      </div>
      <autocomplete-article
        :class="{ 'is-invalid': highlightFields && (!data.article || !data.article.id) }"
        :original-title="data.article ? data.article.title : ''"
        @input="selectedArticle"
        :disable-private="disablePrivate"
      />
    </div>

    <form-control
      class="mb-3"
      v-model="data.title"
      :errors="highlightFields && !data.title ? [' '] : []"
      :no-margin="true"
      :title="`Article Title`"
      :placeholder="`Enter title`"
      @input="$emit('input', data)"
    />

    <form-control
      class="mb-3"
      v-model="data.marketingBullet1"
      :errors="highlightFields && !data.marketingBullet1 ? [' '] : []"
      :no-margin="true"
      :title="`Summary bullet 1`"
      :placeholder="`Enter deck bullet 1`"
      @input="$emit('input', data)"
    />

    <form-control
      class="mb-3"
      v-model="data.marketingBullet2"
      :errors="highlightFields && !data.marketingBullet2 ? [' '] : []"
      :no-margin="true"
      :title="`Summary bullet 2`"
      :placeholder="`Enter deck bullet 2`"
      @input="$emit('input', data)"
    />

    <form-control
      class="mb-3"
      v-model="data.marketingBullet3"
      :errors="highlightFields && !data.marketingBullet3 ? [' '] : []"
      :no-margin="true"
      :title="`Summary bullet 3`"
      :placeholder="`Enter deck bullet 3`"
      @input="$emit('input', data)"
    />

    <div v-if="withImage">
      <div class="form-group">
        <label>Article image upload</label>
        <img
          v-if="data.image"
          :src="data.image.url"
          :alt="data.image.name"
          class="d-block mb-2"
          style="max-width: 520px;"
        />
        <FileUpload
          :value="data.image ? [data.image] : []"
          :headers="headers"
          :action="`${url}upload/image`"
          @input="pictureUploaded"
          :accept="['image/png', 'image/jpeg']"
        />
      </div>
    </div>

    <div class="form-group">
      <div class="d-flex justify-content-between">
        <label>Article synopsis (optional)</label>
      </div>

      <HtmlEditor
        v-model="data.synopsis"
        :no-margin="true"
        :placeholder="`Enter synopsis`"
        :class="{ 'is-invalid': (highlightFields && !data.synopsis) }"
        class="mb-3"
        type="textarea"
        @input="$emit('input', data)"
      />
    </div>

    <a
      v-if="removable"
      @click="$emit('remove')"
      class="btn btn-outline-danger text-danger ml-auto"
    >Remove Article</a>
  </div>
</template>

<script>
import he from 'he'
import AutocompleteArticle from '@/components/AutocompleteArticle'
import ColorInput from '../Components/ColorInput'
import { HtmlEditor, FileUpload } from '@frontend/components'
import gateway from '@/gateway'
import striptags from 'striptags'
import {apolloClient} from '../../../../apollo'
import gql from 'graphql-tag'

export default {
  components: {
    AutocompleteArticle,
    FileUpload,
    HtmlEditor,
  },
  props: {
    disablePrivate: {
      type: Boolean,
      default: false
    },
    useSummarizer: {
      type: Boolean,
      default: false
    },
    withImage: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      required: false,
      default() {
        return {
          title: '',
          synopsis: ''
        }
      }
    },
    removable: {
      type: Boolean,
      required: false,
      default: false
    },
    highlightFields: {
      required: false,
      type: Boolean,
      default: false
    },
    autocompleteDisabled: {
      type: Boolean,
      default: false
    },
    striptags: {
      type: [Boolean, Array, String],
      default: false
    }
  },
  computed: {
    headers() {
      return {
        Authorization: 'Bearer ' + this.$login.getToken()
      }
    },
    synLength() {
      return (this.data.synopsis || '').replace(/<\/?[^>]+(>|$)/g, '').length
    }
  },
  data() {
    return {
      data: this.value,
      error: null,
      url: process.env.VUE_APP_API_ENDPOINT
    }
  },

  methods: {
    async getSummary(article) {

      try {
        const response = await gateway.post('summarizer', {
          model: 'xlnet-base-cased',
          ratio: 0.15,
          min_length: 25,
          max_length: 400,
          body: article.starterBody
        })

        var tmp = document.createElement('DIV')
        tmp.innerHTML = response.data

        return (tmp.textContent || tmp.innerText || '')
          .replace('\n', '<br>')
      } catch (e) {
        console.log(e, e.response)
        return ''
      }
    },
    stripTags(text) {
      if (this.striptags === false) {
        return text
      }

      return this.striptags ? striptags(text, this.striptags) : striptags(text)
    },
    async selectedArticle(article) {
      if (article) {
        const response = await apolloClient.query({
          query: gql`
            query {
              newArticle(id: ${article.id}) {
                value {
                  starterBulletOne
                  starterBulletTwo
                  starterBulletThree
                  starterBody
                  image
                  starterTitle
                  leadAnalyst {
                    name
                    jobTitle
                    picture {
                      square
                    }
                    channel {
                      name
                    }
                    slug
                  }
                }
              }
            }
          `
        })
        article = response.data.newArticle.value
        console.log('this is the article response', article)
        const { id, slug, image } = article
        const data = {
          id,
          slug,
          title: article.starterTitle,
          analyst: article.leadAnalyst
            ? {
                name: article.leadAnalyst.name,
                job_title: article.leadAnalyst.jobTitle,
                picture_url: article.leadAnalyst.picture.square,
                company: article.leadAnalyst.channel ? article.leadAnalyst.channel.name : null,
                slug: article.leadAnalyst.slug
              }
            : null
        }

        this.data.article = data
        this.data.title = article.starterTitle
        this.data.synopsis = this.stripTags(
          this.useSummarizer
            ? await this.getSummary(article)
            : (he.decode(article.starterBody) || '')
        )

        this.data.marketingBullet1 = article.starterBulletOne
        this.data.marketingBullet2 = article.starterBulletTwo
        this.data.marketingBullet3 = article.starterBulletThree
        if(image) {
          this.data.image = {
            url: image,
            title: `${article.starterTitle} Hero Image`
          }
        } else {
          this.data.image = null
        }
      } else {
        this.data.article = null
        this.data.title = ''
        this.data.synopsis = ''
      }
      this.$emit('input', this.data)
    },

    selectedTextColor(color) {
      this.data.textColor = color
      this.$emit('input', this.data)
    },

    selectedBackgroundColor(color) {
      this.data.backgroundColor = color
      this.$emit('input', this.data)
    },

    pictureUploaded(fileList) {
      const img = !fileList[0]
        ? null
        : {
            name: fileList[0].name,
            url: fileList[0].url
          }

      this.data.image = img
      this.$forceUpdate()
      this.$emit('input', this.data)
    }
  }
}
</script>
